'use client'

import { getTranslation } from 'labels/lib/getTranslation/getTranslation'
import type { LabelsContextType } from 'labels/types'
import {
	createContext,
	type ReactNode,
	useCallback,
	useMemo,
	useState,
} from 'react'
import type { Labels } from 'types/labels'

export const StateLabelsContext = createContext<LabelsContextType | undefined>(
	undefined
)
export const SetStateLabelsContext = createContext<(newLabels: Labels) => void>(
	() => {
		/* do nothing */
	}
)

export function LabelsProvider({
	children,
	labels = {},
	locale,
}: {
	readonly children: ReactNode
	readonly labels: Labels | undefined
	readonly locale: string
}) {
	const [state, setState] = useState<Labels>(labels)

	const setLabels = useCallback((newLabels: Labels) => {
		setState((prev) => ({ ...prev, ...newLabels }))
	}, [])

	const value = useMemo(
		() => ({
			t: (key: string, amount?: number): string =>
				getTranslation({
					key,
					amount,
					locale,
					translations: state,
				}),
			labels: state,
		}),
		[state, locale]
	)

	return (
		<StateLabelsContext.Provider value={value}>
			<SetStateLabelsContext.Provider value={setLabels}>
				{children}
			</SetStateLabelsContext.Provider>
		</StateLabelsContext.Provider>
	)
}
